module.exports = __webpack_public_path__ + "91d9fac44c73458433a0f1d1fd6977ff.svg";